var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { BehanceIcon } from './icons/Behance';
import { DribbbleIcon } from './icons/Dribbble';
import { FacebookIcon } from './icons/Facebook';
import { InstagramIcon } from './icons/Instagram';
import { LinkedinIcon } from './icons/Linkedin';
import { MediumIcon } from './icons/Medium';
import { TiktokIcon } from './icons/Tiktok';
import { TwitchIcon } from './icons/Twitch';
import { TwitterIcon } from './icons/Twitter';
import { VimeoIcon } from './icons/Vimeo';
import { WhatsappIcon } from './icons/Whatsapp';
import { YoutubeIcon } from './icons/Youtube';
import { SocialSection as SocialSectionStyle } from './styles';
var getSocial = function (id, theme) {
    switch (id) {
        case 'facebook':
            return (_jsx(FacebookIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'instagram':
            return (_jsx(InstagramIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'linkedin':
            return (_jsx(LinkedinIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'twitter':
            return (_jsx(TwitterIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'whatsapp':
            return (_jsx(WhatsappIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'youtube':
            return (_jsx(YoutubeIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'dribbble':
            return (_jsx(DribbbleIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'behance':
            return (_jsx(BehanceIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'medium':
            return (_jsx(MediumIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'twitch':
            return (_jsx(TwitchIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'tiktok':
            return (_jsx(TiktokIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
        case 'vimeo':
            return (_jsx(VimeoIcon, { color: theme.iconsBackground, background: theme.iconsColor }, void 0));
    }
};
export var Social = function (_a) {
    var section = _a.section;
    var theme = useTheme();
    var socials = [
        'facebook',
        'instagram',
        'whatsapp',
        'twitter',
        'linkedin',
        'youtube',
        'behance',
        'dribbble',
        'medium',
        'twitch',
        'tiktok',
        'vimeo',
    ]
        .filter(function (property) { return !!section[property]; })
        .map(function (property) { return ({
        id: property,
        url: section[property],
    }); });
    var whatsapp = socials.find(function (_a) {
        var id = _a.id;
        return id === 'whatsapp';
    });
    if (whatsapp && !whatsapp.url.startsWith('http')) {
        whatsapp.url = "https://api.whatsapp.com/send?phone=" + whatsapp.url;
    }
    return socials.length ? (_jsx(SocialSectionStyle, { children: _jsx("div", { children: socials.map(function (_a) {
                var id = _a.id, url = _a.url;
                return (_jsx("a", __assign({ href: url, target: "_blank", rel: "noreferrer", id: id }, { children: getSocial(id, theme) }), id));
            }) }, void 0) }, void 0)) : null;
};
